import React from 'react'
import gql from 'graphql-tag'
import { Mutation } from 'react-apollo'
import { PureQueryOptions } from 'apollo-client'
import { LibraryFilterArg } from '../../../../graphql/schema/types/library-filter-arg'

export const updateApplicationLibraryStatusByFiltersMutation = gql`
  mutation UpdateApplicationLibraryStatusByFilters(
    $organizationID: ID!
    $applicationID: ID!
    $filters: LibraryFilterArg!
    $excludedHashes: [ID!]!
    $status: ApplicationLibraryStatusType!
  ) {
    updateApplicationLibraryStatusByFilters(
      input: {
        organizationID: $organizationID
        applicationID: $applicationID
        filters: $filters
        excludedHashes: $excludedHashes
        status: $status
      }
    ) {
      _placeholder
    }
  }
`

export interface UpdateApplicationLibraryStatusByFiltersMutationArgs {
  readonly organizationID: string
  readonly applicationID: string
  readonly filters: LibraryFilterArg
  readonly excludedHashes: string[]
  readonly status: string
}

export function UpdateApplicationLibraryStatusByFiltersMutation({
  children
}: {
  readonly children: (
    updateApplicationLibraryStatus: (
      variables: UpdateApplicationLibraryStatusByFiltersMutationArgs,
      refetchQueries: PureQueryOptions[]
    ) => Promise<any>
  ) => React.ReactNode
}) {
  return (
    <Mutation<{}, UpdateApplicationLibraryStatusByFiltersMutationArgs>
      mutation={updateApplicationLibraryStatusByFiltersMutation}
    >
      {(updateApplicationLibraryStatusByFilters) => {
        return children(
          async (
            variables: UpdateApplicationLibraryStatusByFiltersMutationArgs,
            refetchQueries
          ) => {
            return updateApplicationLibraryStatusByFilters({
              variables,
              refetchQueries
            })
          }
        )
      }}
    </Mutation>
  )
}
